<template>
  <ul v-if="showTemplate" class="employee-overview-statistics m_t8 m_b8" v-loading="loading">
    <li
      v-if="statisticsData.preEntryCount"
      class="count c_pointer sk--hover-item"
      @click="handleToLink(true,'entry',statisticsData.preEntryFilterType,'020901')"
    >
      <span class="sk-color">{{statisticsData.preEntryCount}}</span>
      <span class="sk-color">{{$xinI18n('待入职','Common-dairuzhi')}}</span>
    </li>
    <li
      v-if="statisticsData.preDismissCount"
      class="count c_pointer sk--hover-item"
      @click="handleToLink(true,'dismiss',statisticsData.preDismissFilterType,'020904')"
    >
      <span class="sk-color">{{statisticsData.preDismissCount}}</span>
      <span class="sk-color">{{$xinI18n('待离职','Common-dailizhi')}}</span>
    </li>
    <li
      v-if="statisticsData.futureSignCount"
      class="count c_pointer sk--hover-item"
      @click="handleToLink(false,'sign',statisticsData.futureSignFilterType,'020410')"
    >
      <span class="sk-color">{{statisticsData.futureSignCount}}</span>
      <span class="sk-color">{{$xinI18n('待续签','employee-daixuqian')}}</span>
    </li>
    <li
      v-if="statisticsData.probationExpiredCount"
      class="count c_pointer sk--hover-item"
      @click="handleToLink(true,'probation',statisticsData.probationExpiredFilterType,'020902')"
    >
      <span class="sk-color">{{statisticsData.probationExpiredCount}}</span>
      <span class="sk-color">{{$xinI18n('试用期到期','Home-remind-shiyongqidaoqi')}}</span>
    </li>
  </ul>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import moment from "moment"
  import {HomeApi} from '@/module/home/service/home-api.service';

  @Component({})
  export default class EmployeeOverviewStatistics extends Vue {
    @Prop({default:''})
    date!:string

    loading = false
    showTemplate = true
    statisticsData = {
      preEntryCount:0,
      preEntryFilterType:'',
      preDismissCount:0,
      preDismissFilterType:'',
      futureSignCount:0,
      futureSignFilterType:'',
      probationExpiredCount:0,
      probationExpiredFilterType:''
    }
    linkMap:{[propNames:string]:string[]} = {
      entry:['/employee/serve-manage/entry?tab=employeeEntryOverdue&filterType=','/employee/serve-manage/entry?tab=employeePendingEntry&filterType='], //今日之前，今日及今日之后
      dismiss:['/employee/serve-manage/dismiss?tab=employeeDimissionOverdue&filterType=','/employee/serve-manage/dismiss?tab=employeePendingDimission&filterType='],
      sign:['/employee/employee-manage/contract?tab=contractSubjectToRenewal&filterType='],
      probation:['/employee/serve-manage/regular?tab=employeeRegularOverdue&filterType=','/employee/serve-manage/regular?tab=employeePendingRegular&filterType='],
    }

    get isBeforeToday(){
      const dateTime:any = moment(this.date,'YYYY/MM/DD').valueOf()
      const nowTime:any = moment().startOf('day').valueOf()
      if(dateTime < nowTime){
        return true // 当日之前
      }else {
        return false //当日及当日之后
      }
    }

    @Watch("date")
    dateChange(nVal:string,oVal:string){
      if(nVal && oVal){
        this.init()
      }
    }

    @Watch("statisticsData",{deep:true})
    statisticsDataChange(nVal:any){
      const { preEntryCount, preDismissCount, futureSignCount, probationExpiredCount} = nVal
      if(preEntryCount || preDismissCount || futureSignCount || probationExpiredCount){
        this.showTemplate = true
      }else{
        this.showTemplate = false
      }
    }

    created(){
      this.init()
    }

    init(){
      this.loading = true
      HomeApi.ajaxGetEmployeeStatisticsCount(this.date).then((result:any) => {
        if(result){
          this.statisticsData = result
          this.loading = false
        }
      });
    }

    //跳转分为今日之前和今日及今日之后
    handleToLink(isBeforeAfter:boolean,type:string,filterType:string,permissionCode:string){
      if(!this.permission.verifyExp(permissionCode)){
        this.$message.error(window.$xinI18n('暂无页面访问权限','workbench-zwymfwqx'));
        return
      }
      let linkArr:string[] = this.linkMap[type]
      let link = ''
      if(isBeforeAfter){
        link = this.isBeforeToday ? linkArr[0] : linkArr[1]
      }else{
        link = linkArr[0]
      }

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','',type)

      //跨模块
      window.location.href = `${link}${filterType}&dateValue=${this.date},${this.date}`
    }
  }
</script>

<style lang="scss" scoped>
.employee-overview-statistics{
  box-sizing: border-box;
  display: flex;
  padding: 8px 0;
  width: 100%;
  height: 52px;
  background: #f4fafc;
  border-radius: 4px;
  &::v-deep .el-loading-spinner{
    margin-top: -12px;
    .circular{
      width: 24px;
      height: 24px;
    }
  }
  .count{
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 25%;
    padding-left: 16px;
    span{
      &:first-child{
        font-size: 16px;
        font-weight: 700;
        color: var(--xs-text-color-primary);
      }
      &:last-child{
        font-size: 12px;
        font-weight: 400;
      }
    }
  }
}
</style>
